import * as React from 'react';
import { Flex } from '../flex';
import { StyledRow, pad } from './Grid.style';

type Props = any & {}

// const valueMapping = {
//     start: 'flex-start',
//     end: 'flex-end',
//     between: 'space-between',
//     around: 'space-around',
//     evenly: 'space-evenly'
// }

const Row: React.FC<Props> = (props: any): React.ReactElement => {
    // const style: any = {}

    // if (props.align) {
    //     style.alignItems = valueMapping[props.align] || props.align
    // }
    // if (props.direction) {
    //     style.flexDirection = props.direction
    // }
    // if (props.justify) {
    //     style.justifyContent = valueMapping[props.justify] || props.justify
    // }
    // if (props.wrap) {
    //     style.flexWrap = props.wrap
    // }

    // return (
    // 	<StyledRow {...style} {...rest} />
    // )

    const {
        gutter,
        children,
        ...rest
    } = props;

    const styledChildren = React.Children.map(children, (child: any, index: number) => {
        if (child && child.type) {
            const childProps = { ...child.props };
            childProps.gutter = gutter;
            return React.cloneElement(child, childProps);
        }
        return child;
    });

    rest.gutter = gutter;
    rest.children = styledChildren;

    return <StyledRow {...rest} />;
};

Row.defaultProps = {
    flexWrap: 'wrap'
};

export default Row;
